import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1199px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'testimonials-section-slider-sidebar': 'testimonials-carousel-sidebar',
    'grid-attorney': 'team-carousel',
    'grid-videos': 'videos-carousel',
    'our-team': 'team-sidebar-widget',
    'verdicts-settlements-slider': 'verdicts-settlements-carousel',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value).then((module) => {
            module.default();
        });
    }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');

if(window.innerWidth >= 768) {
    const paBox = new MatchHeight('.practice-area-box');
}

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
    'click',
    (event) => {
        if (!event.target.closest('.scroll')) return;

        const hashValue = event.target.closest('.scroll').getAttribute('href');
        const target = document.querySelector(hashValue);

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        history.pushState(null, null, hashValue);
        event.preventDefault();
    },
    false
);

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}

/**
 * Video Popup Modal
 */
const videoPlayBtn = document.querySelector('.video-play-btn');
const videoModal = document.getElementById('heroVideoModal');

if (videoPlayBtn && videoModal) {
    const videoElement = videoModal.querySelector('.video-modal__video');
    const closeBtn = videoModal.querySelector('.video-modal__close');
    const overlay = videoModal.querySelector('.video-modal__overlay');

    const openModal = () => {
        videoModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        videoElement.play();
    };

    const closeModal = () => {
        videoModal.classList.remove('is-open');
        document.body.style.overflow = '';
        videoElement.pause();
        videoElement.currentTime = 0;
    };

    videoPlayBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && videoModal.classList.contains('is-open')) {
            closeModal();
        }
    });
}

// Improved logic: Uses Swiper instance if available, else fallback to manual visibility calculation.
// Ensures .is-last-visible is set correctly, even if Swiper doesn't add/removes slides dynamically.

function setIsLastVisibleSlide(swiper) {
    // Remove modifier from all slides first
    const slides = document.querySelectorAll('.verdicts-settlements-slider .swiper-slide');
    slides.forEach(slide => slide.classList.remove('is-last-visible'));

    let lastVisibleSlide = null;

    if (swiper) {
        // Swiper instance provided, use Swiper's visibleIndexes
        let lastVisibleIndex = null;

        if (swiper.visibleSlides && swiper.visibleSlides.length) {
            // Swiper >=7: visibleSlides
            lastVisibleSlide = swiper.visibleSlides[swiper.visibleSlides.length - 1];
        } else if (typeof swiper.visibleSlidesIndexes !== 'undefined' && swiper.visibleSlidesIndexes.length > 0) {
            // Visible indexes array (not standard)
            lastVisibleIndex = swiper.visibleSlidesIndexes[swiper.visibleSlidesIndexes.length - 1];
        } else if (swiper.slides && swiper.slides.length && typeof swiper.params.slidesPerView !== 'undefined') {
            // Calculate using Swiper's activeIndex + slidesPerView - 1
            let spv = swiper.params.slidesPerView;
            let active = swiper.activeIndex;
            if (typeof spv === 'number') {
                lastVisibleIndex = Math.min(active + spv - 1, swiper.slides.length - 1);
            } else if (typeof spv === 'string' && spv === 'auto') {
                // If slidesPerView is 'auto', find the last slide that is even partially visible
                let sliderRect = swiper.el.getBoundingClientRect();
                let visibleSlidesArr = Array.from(swiper.slides).filter(slide => {
                    let rect = slide.getBoundingClientRect();
                    return (rect.left < sliderRect.right) && (rect.right > sliderRect.left);
                });
                if (visibleSlidesArr.length) lastVisibleSlide = visibleSlidesArr[visibleSlidesArr.length - 1];
            }
        }
        if (!lastVisibleSlide && lastVisibleIndex !== null && typeof swiper.slides[lastVisibleIndex] !== 'undefined') {
            lastVisibleSlide = swiper.slides[lastVisibleIndex];
        }
    } else {
        // No Swiper instance: fallback, use manual visibility
        const slider = document.querySelector('.verdicts-settlements-slider');
        if (!slider) return;
        const slidesArr = Array.from(slider.querySelectorAll('.swiper-slide'));
        if (!slidesArr.length) return;
        const sliderRect = slider.getBoundingClientRect();
        const visibleSlides = slidesArr.filter(slide => {
            const rect = slide.getBoundingClientRect();
            return (rect.left < sliderRect.right) && (rect.right > sliderRect.left);
        });
        if (visibleSlides.length) lastVisibleSlide = visibleSlides[visibleSlides.length - 1];
    }

    if (lastVisibleSlide) {
        lastVisibleSlide.classList.add('is-last-visible');
    }
}

function attachLastSlidePaddingFix() {
    // Try to use Swiper instance if available, fallback otherwise.
    function tryAttachSwiperEvents() {
        const sliderEl = document.querySelector('.verdicts-settlements-slider.swiper');
        if (sliderEl && sliderEl.swiper) {
            // Listen for slide change, update, resize, transition
            const swiper = sliderEl.swiper;
            // Call once to set state
            setIsLastVisibleSlide(swiper);
            swiper.on('slideChange transitionEnd update resize', function() {
                setIsLastVisibleSlide(swiper);
            });
        } else {
            // No Swiper instance found yet, fallback - set it once, and also on resize
            setIsLastVisibleSlide(null);
        }
    }
    // Initial call on DOM ready (in case Swiper already initialized)
    tryAttachSwiperEvents();

    // Fallback: if Swiper is not loaded instantly, delay, or wait for future DOM updates
    // Try again when DOM changes (e.g., SPA, partial refresh, or late swiper attach)
    let tried = false;
    const observer = new MutationObserver(() => {
        if (!tried) {
            tryAttachSwiperEvents();
            tried = true;
            setTimeout(() => { tried = false; }, 300); // Debounce: allow detach/reattach
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', function() {
        // Always update on resize, fallback if Swiper not used/can't detect slides
        tryAttachSwiperEvents();
    });
}

document.addEventListener('DOMContentLoaded', attachLastSlidePaddingFix);
